import React, { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'

import { useI18n } from '@affiliate-cabinet/i18n'
import { Badge, Link, mediaHelper, Skeleton, Text, useMediaQuery } from '@affstore-ds/uikit'

import { handleNavigate } from '../../../../shared/navigation/handleNavigate'
import { routes } from '../../../../shared/routes'
import { useLoyaltyLevels } from '../..'
import { LoyaltyLevelsTranslations } from '../../lib/translations/LoyaltyLevels.translations'

import { useLevelBadgeStyles } from './LevelBadge.styled'

export const LevelBadge = () => {
  const navigate = useNavigate()
  const { currentLevel, loading } = useLoyaltyLevels()

  const isGreaterThenSm = useMediaQuery(mediaHelper.greaterThen('sm', false))

  const levelName = useMemo(() => currentLevel?.name || '', [currentLevel?.name])
  const translationKey = useMemo(() => LoyaltyLevelsTranslations[levelName as keyof typeof LoyaltyLevelsTranslations], [levelName])

  const { classes } = useLevelBadgeStyles({ levelName })
  const { i18n } = useI18n()

  if (loading) {
    return <Skeleton width={80} height={32} />
  }

  if (!levelName) {
    return null
  }

  return (
    <Link href={routes.ROUTES_LOYALTY_PROGRAM.root} onClick={handleNavigate(navigate, routes.ROUTES_LOYALTY_PROGRAM.root)}>
      <Badge elementSize={isGreaterThenSm ? 'l' : 's'} classNames={{ root: classes.root }}>
        <Text className={classes.label} elementSize={isGreaterThenSm ? 's' : 'xs'} elementVariant="important" tt="uppercase">
          {i18n.t(translationKey || '')}
        </Text>
      </Badge>
    </Link>
  )
}
